export default "__VITE_ASSET__Cph7pG$c__"